import {Property} from "csstype";
import {FunnelKey} from "./Keys";
import {Funnel} from "./Funnel";

type MainFunnelCellState = {
    IsSelected: boolean;
    BackgroundColor: Property.BackgroundColor;

    PrevFunnelKeyOrNull: FunnelKey | null;
    NextFunnelKeyOrNull: FunnelKey | null;
    Collaborators: string[];
}

export class MainFunnelCell {

    private readonly funnel: Funnel;
    private readonly state: MainFunnelCellState;


    constructor(funnel: Funnel, state: MainFunnelCellState) {
        this.funnel = funnel;
        this.state = state;
    }

    get Funnel(): Funnel {
        return this.funnel;
    }

    get State(): MainFunnelCellState {
        return this.state;
    }
}

export class MainFunnelLine {
    private cells: MainFunnelCell[];

    constructor(main_funnel_cells: MainFunnelCell[]) {
        this.cells = main_funnel_cells;
    }

    mapCells<U>(callbackfn: (cell: MainFunnelCell, index: number, array: MainFunnelCell[]) => U): U[] {
        return this.cells.map(callbackfn);
    }

    getSelectedCellOrNull(): MainFunnelCell | null {
        return this.cells.find(c => c.State.IsSelected) ?? null;
    }
}
